const emptyProps = {
  image: {
    type: String,
    default: ""
  },
  imageSize: Number,
  description: {
    type: String,
    default: ""
  }
};

export { emptyProps };
//# sourceMappingURL=empty.mjs.map
